// extracted by mini-css-extract-plugin
export default {"productDescription":"F_-z","featuredDescription":"G_-z","description":"H_-z","more":"I_-z","descriptionSku":"J_-z"};